import { useTranslation } from 'react-i18next'

import { Flex } from '@enechain/ecloud-designsystem'

import { CompactAlert } from '~/components/common/CompactAlert'

export const ClientUpdateRequiredView = (): React.ReactElement => {
  const { t } = useTranslation()
  return (
    <Flex
      alignItems="center"
      justifyContent="center"
      height="300px"
      paddingX={4}
    >
      <CompactAlert
        status="error"
        title={t(
          'page:demandForecastDaily.save.serverError.reason.clientUpdateRequired',
        )}
      />
    </Flex>
  )
}
